export const isFinalCustomer = (type: number) => ({ finalCustomer: type === 3 });

export enum ClientTypes {
  DEFAULT = 1,
  GHOST = 2,
  ANONYMOUS = 3,
}
